<template>
  <div class="advantage">
    <div class="page-wit">
      <div class="title">
        <h2>
          <span class="tit-l">
            <img src="@/assets/images/partner/tit-l.png" width="34" />
          </span>我们的三大优势
          <span class="tit-r">
            <img src="@/assets/images/partner/tit-r.png" width="35" />
          </span>
        </h2>
      </div>

      <div class="advan-list">
        <div class="advan-item red">
          <span class="bg colour-a"></span>
          <span class="sequ">
            <img src="@/assets/images/partner/advan-one.png" width="74" />
          </span>
          <h2>品牌优势</h2>
          <p class="mat-a">美菜网作为行业知名品牌，更容易获得市场认可。</p>
        </div>
        <div class="advan-item yellow">
          <span class="bg colour-b"></span>
          <span class="sequ">
            <img src="@/assets/images/partner/advan-two.png" width="74" />
          </span>
          <h2>强大的技术支持</h2>
          <p
            class="mat-b"
          >美菜网自建数百人研发团队，历时三年，耗资近3亿元，打造了生鲜B2B行业最高效、智能IT系统！使生鲜运营、仓配的成本降低30%以上！为代理商提供了强大、全面的技术保障。</p>
        </div>
        <div class="advan-item none bule">
          <span class="bg colour-c"></span>
          <span class="sequ">
            <img src="@/assets/images/partner/advan-three.png" width="74" />
          </span>
          <h2>丰富的优势产品</h2>
          <p
            class="mat-c"
          >美菜网拥有近万种商品资源，全面满足商户一站式购买需求，我们几乎与业内所有全国性大品牌签订了战略合作协议，初步建立了餐饮行业所需的核心商品的全球源头采购体系、全国联采体系和自有品牌体系。</p>
        </div>
      </div>
      <div class="clear"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "support",
  data() {
    return {
      dialogVisbility: false
    };
  }
};
</script>

<style lang="scss" scoped>
.advantage {
  padding: 80px 0;
  .title {
    height: 125px;
    h2 {
      font-size: 34px;
      position: relative;
      width: 340px;
      margin: 0 auto;
      text-align: center;
    }
  }
}
.advan-list{
  display: flex;
  justify-content: space-between;
}
.advan-item {
  width: 294px;
  height: 338px;
  background: #fff;
  border: 1px solid #fff;
  position: relative;
  .sequ {
    position: absolute;
    top: -10px;
    left: 25px;
  }
  .bg {
    width: 70px;
    height: 1px;
    position: absolute;
    top: -1px;
    left: 27px;
  }
  .colour-a {
    background: #fdf2f1;
  }
  .colour-b {
    background: #f9f4ed;
  }
  .colour-c {
    background: #f2f9fa;
  }
  h2 {
    font-size: 24px;
    padding: 60px 10px 40px;
    text-align: center;
  }
  p {
    padding: 0 30px;
    font-size: 15px;
    color: #757575;
    line-height: 1.6;
  }
  p.mat-a {
    padding: 48px 55px 0;
  }
  p.mat-b {
    padding: 12px 30px 0;
  }
}
.red {
  background: #fdf2f1;
  border: 1px solid #f8b2b4;
}
.yellow {
  background: #f9f4ed;
  border: 1px solid #fdd189;
}
.bule {
  background: #f2f9fa;
  border: 1px solid #76dbea;
}
</style>
